export default __webpack_public_path__ + "static/media/medical_16.3b09fa2c.jpg";